import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import isObject from 'lodash/isObject';
import PropTypes from 'prop-types';
import { loggerFactory } from 'paysera-logger';
import getComponentName from "../service/getComponentName";
var withLogger = function withLogger() {
  var loggerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (BaseComponent) {
    var WithLogger = /*#__PURE__*/function (_PureComponent) {
      _inherits(WithLogger, _PureComponent);
      var _super = _createSuper(WithLogger);
      function WithLogger(props) {
        var _this;
        _classCallCheck(this, WithLogger);
        _this = _super.call(this, props);
        _this.logger = loggerFactory(loggerName || getComponentName(BaseComponent));
        _this.captureException = _this.captureException.bind(_assertThisInitialized(_this));
        _this.raven = window.Raven;
        return _this;
      }
      _createClass(WithLogger, [{
        key: "captureException",
        value: function captureException(error) {
          for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            restArgs[_key - 1] = arguments[_key];
          }
          if (isObject(error) && isObject(error.response)) {
            if (error.response.status >= 500 || error.response.status <= 0) {
              this.logger.captureException('Request failed', {
                config: error.config,
                request: error.request,
                response: error.response,
                args: restArgs
              });
              return typeof this.raven !== 'undefined' ? this.raven.lastEventId() : null;
            }

            // don't capture responses with status > 0 && status < 500
            // eslint-disable-next-line consistent-return
            return null;
          }
          this.logger.captureException(error, {
            args: restArgs
          });
          return typeof this.raven !== 'undefined' ? this.raven.lastEventId() : null;
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, this.props, {
            loggerHandler: {
              captureException: this.captureException,
              logError: this.logger.error,
              captureBreadcrumb: this.logger.captureBreadcrumb
            }
          }));
        }
      }]);
      return WithLogger;
    }(PureComponent);
    return WithLogger;
  };
};
export default withLogger;
export var withLoggerPropTypes = {
  loggerHandler: PropTypes.shape({
    captureException: PropTypes.func.isRequired,
    logError: PropTypes.func.isRequired,
    captureBreadcrumb: PropTypes.func.isRequired
  }).isRequired
};